export default {
    400: {
        title: "错误的请求",
        header: "@:views.errors.400.title",
        html: "请求错误，请稍后再试。"
    },
    401: {
        title: "登录时遇到错误。",
        header: "@:views.errors.401.title",
        html: "请联系<a href='{email}' target='_blank'>客服</a>。"
    },
    404: {
        title: "页面未找到",
        header: "@:views.errors.404.title"
    },
    403: {
        title: "访问权限不足",
        header: "访问权限不足",

        contact: "O-I 此外围设备仅供员工使用。如果您是员工并看到此消息，请联系您所在部门的人力资源部门更新您的状态。",

        subject: "装备 - 资格",

        html: "<p class='text-start'> @:views.errors.403.contact</p>",
        error: {
            disabled: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>您目前不符合资格。请联系<a href='#' role='button' data-widget-trigger='{widgetOptions}'>客服</a>了解更多信息。</p>"
            },
            "not-active": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>您目前不符合资格。请联系您当地的人力资源和文化部门了解更多信息。</p>"
            },
            "not-allowed":{
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I 此外围设备仅供员工使用。如果您是员工并看到此消息，请联系您所在部门的人力资源部门更新您的状态。</p>"
            },
            "no-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>您的 ServiceNow 个人资料中未列出有效的经理信息。请联系您当地的人力资源代表，更新您的经理信息。</p>"
            },
            "self-manager": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>您在 ServiceNow 个人资料中设置的经理是您本人。请联系您当地的人力资源代表，更新您的经理信息。</p>"
            },
            "no-location": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>您的 ServiceNow 个人资料中未列出办公地点。请联系您当地的人力资源代表更新您的办公地点信息。</p>"
            },
            eligibility: {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>O-I 此外围设备仅供员工使用。如果您是员工并看到此消息，请联系您所在部门的人力资源部门更新您的状态。</p>",
            },
            "eligibility-location": {
                header: "",
                html: "感谢您对 O-I 外设的关注。目前，该项目在您所在的国家/地区暂不可用。",
            },
            "secondary-account": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>您目前尝试使用辅助帐户访问 O-I 外围设备。请尝试使用您的主帐户重新登录。</p>"
            },
            "empty-core-id": {
                header: "@:views.errors.403.header",
                html: "<p class='text-start'>您的 ServiceNow 帐户没有帐户名称。请联系您当地的人力资源代表更新您的帐户。</p>"
            },
            country: {
                header: "@:views.errors.403.header",
                html: " @:views.errors.403.contact",
            },
            "no-permissions": {
                header: "无访问权限",
                subject: "无访问权限",
                html: "您没有权限打开此页面。",
            },
            "virtual-denied": {
                header: "看来你来得有点早……",
                html: "<p class='text-start'>感谢您对 O-I Peripheral 的关注。看来您是在获得激活和直接邀请之前访问了本网站。O-I Peripheral 正在分阶段、分国家/地区和分用户群体推出。激活后，您将收到一封包含个人邀请和使用说明的电子邮件。</p><p class='text-start'>如果您对订单或网站有任何疑问或问题，请点击<a href='#' role='button' data-widget-trigger='{widgetOptions}'>“支持”</a> 。</p>",
            }
        }
    },
    500: {
        title: "意外错误",
        header: "@:views.errors.500.title",
        message: "发生错误，请稍后重试。"
    },
    code: {
        title: "意外错误",
        message: "@:views.errors.code.title",
        error: "错误 {code}。"
    }
}